import { RenewMode } from '../models/renew-mode.model';
export class AddRenewMode {
    static readonly type = '[RenewMode] Add';
    constructor(public payload: RenewMode) {}
}

export class RemoveRenewMode {
    static readonly type = '[RenewMode] Remove';
    constructor(public payload: RenewMode) {}
}

export class ClearRenewMode {
    static readonly type = '[RenewMode] Clear';
    constructor() {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-merge-customer/actions/renew-mode.action.ts